<template>
  <div v-if="!Array.isArray(events)">
    <v-row no-gutters class="pt-5">
      <v-col class="text-center caption font-italic">
        All times are shown in {{ timezone }} time.
      </v-col>
    </v-row>
    <v-row class="d-print-none" no-gutters>
      <v-col class="text-center caption font-italic" v-if="showbar">
        (Click title or channel for expanded channel details)
      </v-col>
    </v-row>
    <v-row class="d-print-none">
      <v-col
        v-for="(event, key) in events"
        v-bind:key="key"
        cols="12"
        class="mt-0 pt-0"
      >
        <v-card flat v-if="showListHeader" class="d-flex mt-0 blue-line">
          <v-card
            flat
            height="28"
            min-width="125"
            class="blue white--text text-center font-weight-bold text-subtitle-1 align-center px-3"
          >
            {{ key }}
          </v-card>
        </v-card>
        <v-row class="my-0">
          <event
            v-for="(broadcast_event, broadcast_key) in event.BroadcastEvents"
            v-bind:key="broadcast_key"
            :event="broadcast_event"
          />
        </v-row>
      </v-col>
    </v-row>
    <!-- PRINT TABLE -->
    <v-simple-table class="d-none d-print-block">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">Event</th>
            <th class="text-center">Time</th>
            <th class="text-left">Channels</th>
          </tr>
        </thead>
        <tbody v-for="(event, key) in events" v-bind:key="key" >
            <tr>
              <td colspan="3">
                <strong>{{ key }}</strong>
              </td>
            </tr>
            <tr v-for="(broadcast_event, broadcast_key) in event.BroadcastEvents" v-bind:key="broadcast_key">
              <td>
                <div v-if="broadcast_event.Description">
                  {{ broadcast_event.MatchupTitle }}
                </div>
                <div v-else>
                  {{ broadcast_event.AwayTeamName }} at {{ broadcast_event.HomeTeamName }}
                </div>
              </td>
              <td style="white-space:nowrap">
                <time-display :event="broadcast_event" />
              </td>
              <td>
                <channel-print v-for="(channel,index) in broadcast_event.MatchingBroadcastEvents"
                    v-bind:key="channel.ChannelNumDisplay" :channel="channel" :index="index" />
              </td>
            </tr>
          
        </tbody>
      </template>
    </v-simple-table>
  </div>
  <loading v-else-if="loading"></loading>
  <no-events v-else></no-events>
</template>

<script>
import Event from "./List/Event";
import TimeDisplay from "./List/Event/Shared/TimeDisplay";
import ChannelPrint from "./List/Event/ChannelPrint";
import Loading from "../shared/Loading";
import NoEvents from "./List/NoEvents";

export default {
  name: "List",
  components: {
    Event,
    TimeDisplay,
    ChannelPrint,
    Loading,
    NoEvents,
  },
  computed: {
    timezone() {
      return this.$store.getters.getCurrentSelectedOptions("timezone");
    },
    showListHeader() {
      return this.$store.getters.getCurrentSelectedOptions("groups") > 0 ||
        this.$route.meta.showbar == false
        ? true
        : false;
    },
    showbar() {
      return this.$route.meta.showbar;
    },
    events() {
      return this.$store.getters.getEvents;
    },
    loading() {
      return this.$store.getters.getLoading;
    },
  },
};
</script>

<style scoped>
.blue-line {
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) calc(50% - 1px),
    rgba(0, 87, 184, 1) calc(50%),
    rgba(0, 0, 0, 0) calc(50% + 1px)
  );
}
</style>